export default __webpack_public_path__ + "static/media/Wristbands of the Whispering Blade.747daf45.jpg";